import { translate } from '@openclassrooms/translations';
import { isCurrentPath } from '@openclassrooms/routing';
import { getLocalisationConfig } from '@openclassrooms/localisation/services';

import mainNavigation from '../../services/mainNavigation';

import HeaderDropDown from './HeaderDropDown';
import HeaderDropDownOverTitle from './HeaderDropDown/HeaderDropDownOverTitle';
import HeaderDropDownGroup from './HeaderDropDown/HeaderDropDownGroup';

interface Props {
  name: string;
  onClick?: () => void;
}

const noop = () => {};

const ApprenticeshipDropDownMenu = ({ name, onClick = noop }: Props) => {
  const navigationConfig = mainNavigation();

  return (
    <HeaderDropDown
      name={name}
      title={
        <HeaderDropDown.Title
          title={translate('main_header.apprenticeship_dropdown.title')}
          subTitle={translate('main_header.training_programs.dropdown.text')}
        />
      }
      items={[
        <HeaderDropDownGroup>
          <HeaderDropDownOverTitle
            title={{
              content: translate('main_header.apprenticeship_dropdown.b2c.overline'),
              index: 0,
            }}
          />
          <HeaderDropDown.Item
            onClick={onClick}
            path={navigationConfig.BECOME_AN_APPRENTICE.path}
            subTitle={translate('main_header.apprenticeship_dropdown.b2c.text')}
            isActive={isCurrentPath(navigationConfig.BECOME_AN_APPRENTICE.path)}
            data-event={navigationConfig.BECOME_AN_APPRENTICE.dataEvent}
          >
            {translate('main_header.apprenticeship_dropdown.b2c.title')}
          </HeaderDropDown.Item>

          {navigationConfig.CONSULT_JOB_OFFERS.shouldBeDisplayed && (
            <HeaderDropDown.Item
              onClick={onClick}
              path={navigationConfig.CONSULT_JOB_OFFERS.path}
              subTitle={translate('main_header.apprenticeship_dropdown.b2c_job.text')}
              isActive={isCurrentPath(navigationConfig.CONSULT_JOB_OFFERS.path)}
              data-event={navigationConfig.CONSULT_JOB_OFFERS.dataEvent}
            >
              {translate('main_header.apprenticeship_dropdown.b2c_job.title')}
            </HeaderDropDown.Item>
          )}
        </HeaderDropDownGroup>,
        <HeaderDropDownGroup>
          <HeaderDropDownOverTitle
            title={{
              content: translate('main_header.apprenticeship_dropdown.business.overline'),
              index: 1,
            }}
          />
          <HeaderDropDown.Item
            onClick={onClick}
            path={navigationConfig.RECRUIT_APPRENTICES.path}
            subTitle={translate('main_header.apprenticeship_dropdown.business.text')}
            isActive={isCurrentPath(navigationConfig.RECRUIT_APPRENTICES.path)}
            data-event={navigationConfig.RECRUIT_APPRENTICES.dataEvent}
          >
            {translate('main_header.apprenticeship_dropdown.business.title')}
          </HeaderDropDown.Item>
          {getLocalisationConfig('apprenticeship.hasTalentPool') && (
            <HeaderDropDown.Item
              onClick={onClick}
              path={navigationConfig.FINALIZE_APPRENTICESHIP.path}
              subTitle={translate('main_header.apprenticeship_dropdown.business_finalize.text')}
              isActive={isCurrentPath(navigationConfig.FINALIZE_APPRENTICESHIP.path)}
              data-event={navigationConfig.FINALIZE_APPRENTICESHIP.dataEvent}
            >
              {translate('main_header.apprenticeship_dropdown.business_finalize.title')}
            </HeaderDropDown.Item>
          )}
        </HeaderDropDownGroup>,
      ]}
    />
  );
};

export default ApprenticeshipDropDownMenu;
